// Constants for different requests for current reducer
export default {
  incidentReportFields: 'INCIDENT_REPORT_FIELDS',
  updateIncidentReportFields: 'UPDATE_INCIDENT_REPORT_FIELDS',
  updateIncidentReportBuilderFields: 'UPDATE_INCIDENT_REPORT_BUILDER_FIELDS',
  addIncidentReportField: 'ADD_INCIDENT_REPORT_FIELD',
  setIncidentReportFieldsUserType: 'SET_INCIDENT_REPORT_FIELDS_USER_TYPE',
  deleteIncidentReportField: 'DELETE_INCIDENT_REPORT_FIELD',
  incidentReportFieldResults: 'INCIDENT_REPORT_FIELD_RESULTS',
};
